import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1a1a1a 0%,rgb(34, 33, 33) 100%);
  border-radius: 12px;
  color: #cccccc;
  padding: 20px 20px;
  text-align: center;
  border-top: 1px solid #333;
  margin-top: auto;
  margin: 0 20px;
`;

const FooterContent = styled.div`
  
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Copyright = styled.span`
  font-size: 0.9rem;
`;

const TOSLink = styled(Link)`
  color: #4CAF50;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
  
  &:hover {
    color: #45a049;
    text-decoration: underline;
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <Copyright>Copyright 2025 YouMeditation.com</Copyright>
        <TOSLink to="/tos">Terms and Conditions</TOSLink>
        <TOSLink to="/privacy">Privacy Policy</TOSLink>
        <TOSLink to="/subscription">Subscription</TOSLink>
        <TOSLink to="/faq">FAQ</TOSLink>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;